import { FilterTypes } from '../models/FilterTypes';

export const FilterAllOption = '\n';

export type FilterQuery = {
  [type in FilterTypes]: { id: string; value: string };
};

export interface FilterState {
  query: FilterQuery;
  isLoadingFilterContent: boolean;
}

export const initialState: FilterState = {
  query: {
    [FilterTypes.owner]: { id: FilterAllOption, value: '' },
    [FilterTypes.modifiedTime]: { id: FilterAllOption, value: '' },
    [FilterTypes.tag]: { id: FilterAllOption, value: '' },
  },
  isLoadingFilterContent: false,
};
